import { ChangeEvent, useState } from "react"

export function useFileForm() {
  const [resume, setResume] = useState<File | null>(null)
  const [errorResume, setErrorResume] = useState("")

  function handleUploadFile(e: ChangeEvent<HTMLInputElement>) {
    const files = e.target.files

    if (!files?.length) {
      return
    }

    setErrorResume("")

    if (files) {
      const file = files[0]

      switch (true) {
        case file.size > 5242880:
          return setErrorResume("File maksimal 5MB")
        case file.type === "application/pdf":
          return setResume(file)
        case file.type === "image/jpeg":
        case file.type === "image/png":
        default:
          setErrorResume("Jenis file harus PDF")
      }
    } else {
      setErrorResume("File belum di input")
    }
  }

  return { resume, handleUploadFile, errorResume, setErrorResume }
}
